import styled from "@emotion/styled";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router-dom";
import routing from "routing";
import { removePolishSign } from "src/helpers/formatHtmlTag";

interface Article {
	id: string | number;
	itemId: string | number;
	title: string;
}

interface ArticlesViewProps {
	className?: string;
	articles: Article[];
}

function ArticlesView({ className, articles }: ArticlesViewProps) {
	const { t } = useTranslation();

	return (
		<div className={className}>
			<Typography variant="body2" component="span">
				{t("relations.relatedArticles")}
			</Typography>
			<List sx={{ padding: 0 }}>
				{articles.map((article) => (
					<ListItem
						button
						disablePadding
						key={article.id}
						component={Link}
						to={generatePath(routing.paths.article, {
							id: article.itemId,
							topic: removePolishSign(article.title),
						})}
					>
						<ListItemText primary={article.title} />
					</ListItem>
				))}
			</List>
		</div>
	);
}

export default styled(ArticlesView)`
  & ul {
    padding: 0;
  }

  & .MuiListItem-root {
    padding: 4px 6px;
  }

  & span {
    font-size: 12px;
    font-weight: normal;
  }

  & .MuiListItemIcon-root {
    color: #65748b;
  }

  & .MuiTypography-body2 {
    padding: 0 8px;
    font-weight: bold;
  }
`;
